import { useEffect, useState } from 'react';
import PrometheusStatService from '../../services/PrometheusStatService';
import PrometheusProxySqlDataSentHostgroupDistributionStats from '../../types/PrometheusProxySqlDataSentHostgroupDistributionStats';

export default function usePrometheusProxySqlDataSentHostgroupDistributionStats(
    uuid: string,
    host_uuid?: string,
    from?: string,
    to?: string
) {
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const [stats, setStats] = useState<
        PrometheusProxySqlDataSentHostgroupDistributionStats[] | undefined
    >(undefined);

    const load = async () => {
        if (uuid && host_uuid) {
            try {
                const details =
                    await PrometheusStatService.getProxySqlDataSentHostgroupDistribution(
                        uuid,
                        host_uuid,
                        from,
                        to
                    );
                setStats(
                    details.map(
                        (d: any) =>
                            new PrometheusProxySqlDataSentHostgroupDistributionStats(
                                d
                            )
                    )
                );
                setError(null);
            } catch (e: any) {
                setError(e);
            }
            setUpdating(false);
            setLoading(false);
        }
    };

    const refresh = () => {
        setUpdating(true);
        load();
        setUpdating(false);
    };

    // get deployments for the given user
    useEffect(() => {
        const init = async () => {
            setLoading(true);
            await load();
            setLoading(false);
        };

        init();
    }, [uuid, host_uuid, from, to]);

    return { stats, refresh, loading, updating, error };
}
